import React from 'react';
import NavigationMenuItem from "./menu-item";
import NavigationSection from "../../../core/model2/navigation/navigation-section";

type State = {
    currentRouteFragment    : string,
    showPopover             : boolean,
    reRender?               : boolean
}

type Props = {
    className?              : string,
    name                    : string,
    icon                    : string,
    url                     : string,
    upgradeRequired         : any // UPGRADE_PRO | UPGRADE_BUSINESS | false,
    navigationSection?      : NavigationSection
    exactUrl?               : boolean,
    saveUrl?                : boolean
}

export default class NavigationMenuItemUrl extends React.Component<Props, State> {

    static defaultProps = {
        upgradeRequired : false
    };

    constructor(props:Props) {
        super(props);

        this.state = {
            currentRouteFragment    : gd.router.history.fragment || '',
            showPopover             : false,
        };
    }

    componentDidMount = () => {
        gd.router.on('route', this.onRoute);
    };

    componentWillUnmount = () => {
        gd.router.off('route', this.onRoute);
    };

    onRoute = () => {
        this.setState({currentRouteFragment: gd.router.history.fragment || ''});
    };

    sessionDataChanged() {
        this.setState({
            reRender: true
        });
    }

    getCurrentRouteFragment = () => gd.router.history.fragment || ''

    render() {
        //includes  string function ... tipo esi est' to vse ... po idee starts from ?
        const isSelected = (this.props.exactUrl)
            ?this.getCurrentRouteFragment() === this.props.url
            :this.getCurrentRouteFragment().includes(this.props.url);


        // {...this.props}
        return <NavigationMenuItem name={this.props.name}
                                   className={this.props.className}
                                   selected={isSelected}
                                   icon={this.props.icon}
                                   url={this.props.url}
                                   navigationSection={this.props.navigationSection}
                                   upgradeRequired={this.props.upgradeRequired}
                                   saveUrl={this.props.saveUrl}

        />
    }

}

